"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormSection = exports.FormValidationGroup = exports.FormRow = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _validate = _interopRequireDefault(require("validate.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formSerialize = _interopRequireDefault(require("form-serialize"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _withNamedError = _interopRequireWildcard(require("../withNamedError"));

require("./form.sass");

var sanitize = function sanitize(data) {
  if (Array.isArray(data)) {
    return data.filter(function (el) {
      return !_validate.default.isEmpty(el);
    });
  }

  if (data instanceof Object) {
    Object.keys(data).forEach(function (key) {
      data[key] = sanitize(data[key]);
    });
  }

  return _validate.default.isEmpty(data) ? null : data;
};

var FormRowComponent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FormRowComponent, _React$Component);

  function FormRowComponent() {
    (0, _classCallCheck2.default)(this, FormRowComponent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(FormRowComponent).apply(this, arguments));
  }

  (0, _createClass2.default)(FormRowComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          error = _this$props.error,
          label = _this$props.label,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["children", "error", "label"]);
      return _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)('form-field', {
          'form-field--error': error
        })
      }, props), label && _react.default.createElement("h3", {
        className: "form-field-label"
      }, label), _react.default.createElement("div", {
        className: "form-fields"
      }, _react.default.Children.toArray(children).map(function (element, index) {
        return _react.default.createElement("div", {
          className: "form-fields-item",
          key: index
        }, element);
      })), error && _react.default.createElement("span", {
        className: "form-field-error"
      }, error));
    }
  }]);
  return FormRowComponent;
}(_react.default.Component);

FormRowComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.default.string,
  label: _propTypes.default.node,
  error: _propTypes.default.node
} : {};
var FormRow = (0, _withNamedError.default)(FormRowComponent);
exports.FormRow = FormRow;

var FormValidationGroupComponent =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2.default)(FormValidationGroupComponent, _React$Component2);

  function FormValidationGroupComponent() {
    (0, _classCallCheck2.default)(this, FormValidationGroupComponent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(FormValidationGroupComponent).apply(this, arguments));
  }

  (0, _createClass2.default)(FormValidationGroupComponent, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          error = _this$props2.error;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('form-field', className, {
          'form-field--error': error
        })
      }, children, error && _react.default.createElement("span", {
        className: "form-field-error"
      }, error));
    }
  }]);
  return FormValidationGroupComponent;
}(_react.default.Component);

FormValidationGroupComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.default.string,
  className: _propTypes.default.string,
  error: _propTypes.default.node
} : {};
var FormValidationGroup = (0, _withNamedError.default)(FormValidationGroupComponent);
exports.FormValidationGroup = FormValidationGroup;

var FormSection = function FormSection(_ref) {
  var className = _ref.className,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('form-section', className)
  }, title && _react.default.createElement("h3", {
    className: (0, _classnames.default)('form-section-header', {
      'form-section-header--withDescription': description
    })
  }, title), description && _react.default.createElement("span", {
    className: "form-section-description"
  }, description), children);
};

exports.FormSection = FormSection;

var _ref2 = _react.default.createElement(_Spinner.default, {
  className: "form-spinner"
});

var Form =
/*#__PURE__*/
function (_React$Component3) {
  (0, _inherits2.default)(Form, _React$Component3);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Form)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      errors: _this.props.errors,
      isSubmitted: !!_this.props.errors
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleChange", function (e) {
      _this.forceUpdate(function () {
        if (_this.state.isSubmitted) {
          _this.setErrors(_this.validate());
        }

        _this.props.onChange && _this.props.onChange(e);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSubmit", function (e) {
      e.preventDefault();

      _this.submit();
    });
    return _this;
  }

  (0, _createClass2.default)(Form, [{
    key: "submit",
    value: function submit() {
      var data = this.getData();
      var errors = this.validate(data);
      this.setErrors(errors);
      this.setState({
        isSubmitted: true
      });

      if (errors) {
        return;
      }

      var onSubmit = this.props.onSubmit;
      onSubmit && onSubmit(data);
    }
  }, {
    key: "getData",
    value: function getData() {
      return sanitize((0, _formSerialize.default)(this.refs.element, {
        hash: true,
        empty: true
      }));
    }
  }, {
    key: "validate",
    value: function validate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getData();
      var _this$props3 = this.props,
          rules = _this$props3.rules,
          validate = _this$props3.validate;
      var result = rules ? (0, _validate.default)(data, rules, {
        fullMessages: false
      }) : undefined;

      if (!validate) {
        return result;
      }

      return validate(data, result);
    }
  }, {
    key: "setErrors",
    value: function setErrors() {
      var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.setState({
        errors: errors
      });
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      return (0, _objectSpread2.default)({}, this.props.errors, this.state.errors);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          isLoading = _this$props4.isLoading,
          children = _this$props4.children;
      return _react.default.createElement(_withNamedError.ErrorsContext.Provider, {
        value: this.getErrors()
      }, _react.default.createElement("form", {
        ref: "element",
        className: (0, _classnames.default)('form', className, {
          'form--loading': isLoading
        }),
        onSubmit: this.onSubmit,
        onChange: this.handleChange,
        onInput: this.handleChange
      }, isLoading && _ref2, _react.default.createElement("div", {
        className: "form-content"
      }, children)));
    }
  }]);
  return Form;
}(_react.default.Component);

exports.default = Form;
Form.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  rules: _propTypes.default.object,
  validate: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  errors: _propTypes.default.object
} : {};